<template>
    <div class="section-container" :class="cssClass">
        <h5 class="section-title">
            <i :class="'fas fa-' + icon"></i>
            {{ title }}
        </h5>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "SectionContainer",
    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            default: 'box'
        },
        cssClass: {
            type: String,
            default: ''
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Modals/Checklist/SectionContainer.vue